export default () => app.timer.draw();
